module.exports = __webpack_public_path__ + "img/DownloadArrow.162963f4.svg";